<template>
  <div class="bg-list">
    <table class="bg-list-container">
      <tr class="bg-list__header">
        <th
          class="bg-list__header-item"
          v-bind:key="header.value"
          v-for="header in headers"
        >
          {{ header.label }}
        </th>
      </tr>

      <tr class="bg-list__item" v-for="item in items" v-bind:key="item.id">
        <td
          class="bg-list__item-col"
          v-for="header in headers"
          v-bind:key="header.value"
        >
          <bg-icon
            v-if="header.icon"
            class="bg-list__icon"
            :name="header.icon"
          />
          <span v-if="!header.format" class="bg-list__icon-text">
            {{ item[header.value] }}
          </span>
          <span v-if="header.format" class="bg-list__icon-text">
            {{ header.format(item[header.value]) }}
          </span>
        </td>
        <td
          class="bg-list__item-col bg-list__item-col--action"
          v-if="admin || actionPerms"
          v-for="action in actions"
          v-bind:key="action.tooltip"
        >
          <bg-tooltip dark>
            <template slot="content">{{ action.tooltip }}</template>
            <template slot="target">
              <bg-icon
                @click.native="
                  $emit('actionClick', { actionType: action.type, ...item })
                "
                class="bg-list__icon--action"
                :name="action.icon"
              />
            </template>
          </bg-tooltip>
        </td>
      </tr>
      <tr v-if="admin" class="bg-list__item bg-list__item--add">
        <td
          @click="$router.push({ path: `/add-member` })"
          :colspan="1000"
          class="bg-list__item__add-content"
        >
          <bg-icon class="bg-list__icon bg-list__icon--add" name="close" />
          <span class="bg-list__icon-text">Add a new member</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import BgTooltip from "@/components/bg-tooltip";

export default {
  name: "BgInput",
  components: {
    BgIcon,
    BgTooltip,
  },
  props: {
    items: Array,
    headers: Array,
    actions: Array,
    admin: Boolean,
    actionPerms: Boolean,
    link: String,
  },
  data() {
    return {
      input: this.value,
    };
  },
};
</script>
